import { HabitSchedule } from '@griply/types';
import { addDays, endOfDay } from 'date-fns';

export const getScheduleEndDate = (schedule?: HabitSchedule | null) =>
  schedule?.endDate ? endOfDay(addDays(schedule.endDate, -1)) : undefined;
